import { Flex, HStack, Text, VStack } from '@chakra-ui/react';
import { format } from 'date-fns';
import React from 'react';

const CommentItem = ({ comment, i }) => {
  return (
    <HStack
      px={'3'}
      bg={i % 2 === 0 ? 'secondary' : 'transparent'}
      justifyContent={'space-between'}
      key={comment.id}
      py={2}
    >
      <VStack w={'full'}>
        <Text w={'full'} fontSize={'14px'}>
          {comment.text}
        </Text>
        <Flex justifyContent={'space-between'} w={'full'} color={'gray'}>
          <Text>{comment.author_name}</Text>
          <Text>{format(new Date(comment.created_at), 'd MMM h:mm a')}</Text>
        </Flex>
      </VStack>
    </HStack>
  );
};

export default CommentItem;
